
import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class UiIcon extends Vue {
  @Prop(String) name!: string

  paths = {
    check: 'M5 12l4 4L19 6',
    bell: 'M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9 M10 21h4',
    clock: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0 M12 6v6l4 2',
    send: 'M22 2 9 15 M22 2l-7 20-4-9-9-4Z',
    spark: 'M12 3l2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5Z',
    inbox: 'M4 4h16l2 10v6H2v-6L4 4Z M2 14h6l2 3h4l2-3h6',
    eye: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12 M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0',
    edit: 'M12 5H5v15h15v-7 M9 15l1-4L19 2l3 3-9 9-4 1Z M16 5l3 3',
    trash: 'M3 6h18 M9 6V3h6v3 M5 6l1 15h12l1-15 M10 10v7 M14 10v7',
    grid: 'M3 3h7v7H3z M14 3h7v7h-7z M3 14h7v7H3z M14 14h7v7h-7z',
    users:
      'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2 M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8 M22 21v-2a4 4 0 0 0-3-3.87 M16 3.13a4 4 0 0 1 0 7.75',
    message: 'M21 11.5a8.5 8.5 0 0 1-8.5 8.5H4l-3 2 2-6a8.5 8.5 0 1 1 18-4.5Z',
    folder: 'M3 7V5a2 2 0 0 1 2-2h5l2 3h7a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z',
    settings: 'M4 7h16 M4 17h16 M8 4v6 M16 14v6',
    search: 'M21 21l-5-5 M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0',
    arrow: 'M5 12h14 M14 7l5 5-5 5',
    chevron: 'M9 5l7 7-7 7',
    plus: 'M12 5v14 M5 12h14',
    close: 'M6 6l12 12 M6 18 18 6',
    menu: 'M4 6h16 M4 12h16 M4 18h16',
    text: 'M4 5h16 M12 5v14 M8 19h8',
    mail: 'M3 5h18v14H3z M3 5l9 8 9-8',
    file: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z M14 2v6h6 M8 13h8 M8 17h5'
  }
}
